// Minimal CSV export helper — builds a CSV from rows (array of objects) + column config.
const esc = (v) => {
  if (v == null) return "";
  const s = String(v).replace(/"/g, '""');
  return /[",\n]/.test(s) ? `"${s}"` : s;
};

// columns: [{ key: "name", label: "Name", get?: (row) => value }]
export const downloadCsv = (filename, columns, rows) => {
  const header = columns.map((c) => esc(c.label ?? c.key)).join(",");
  const body = rows
    .map((r) => columns.map((c) => esc(c.get ? c.get(r) : r[c.key])).join(","))
    .join("\n");
  const csv = `${header}\n${body}`;
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const stamp = new Date().toISOString().slice(0, 10);
  link.download = `${filename}_${stamp}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
